import { AppConfig } from "types/appConfig";

export const config: AppConfig = {
  name: 'ta-mission',
  allowDefineIndivTripCost: true,
  allowSelectTripProtection: true,
  allowSpreadSheetImportTool: true,
  allowUseSponsorship: true,
  allowUsePrimaryInsuredPurchase: false,
  mtiApiUrl: "https://mti-nextgen-api.azurewebsites.net",
  selfUrl: "https://triparmor.missiontripinsurance.com",
  gaId: "G-4X0YNFVQJ8",
  defaultAgentNumber: "16197TA",
  apiUrl: "https://services.imglobal.com/API"
}